/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { NOTIFICATION_TYPES_ARRAY } from '../../../config/config';

const FormDialog = ({ showDialog, setReload, notiData }) => {
  const [busy, setBusy] = useState(false);

  const notificationType = NOTIFICATION_TYPES_ARRAY.find(
    (noti) => noti.id === notiData.type_id
  )?.title || 'Unknown';

  return (
    <Modal
      open
      title="Notification Details"
      width="50%"
      confirmLoading={busy}
      centered
      onCancel={(event) => {
        const { target, keyCode } = event;
        if (['svg', 'span'].includes(String(target.nodeName).toLowerCase())) showDialog(false);
        if (keyCode === 27) showDialog(false);
      }}
      cancelButtonProps={{
        disabled: busy,
      }}
      destroyOnClose
      closable
      footer={[
        <div key="1">
          <Button size="default" type="primary" key="back" outlined onClick={() => showDialog(false)}>
            Close
          </Button>
        </div>,
      ]}
    >
      <div>
        <Cards headless border size="default">
          <div className="flex flex-col w-full gap-4">
            {/* Notification Type Row */}
            <div className="flex w-full">
              <div className="w-1/4 font-bold">Notification Type:</div>
              <div className="w-3/4 text-black font-bold ">{notificationType}</div>
            </div>

            {/* Description Row */}
            <div className="flex w-full">
              <div className="w-1/4 font-bold">Description:</div>
              <div className="w-3/4 text-sm">{notiData.description}</div>
            </div>
          </div>
        </Cards>
      </div>
    </Modal>
  );
};

export default FormDialog;
